import React from 'react';
import { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DContext from '../../context/DContext';



const SideBar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { authState, authDispatch, logout } = useContext(DContext);
    const { user, menu_access, deviceInfo } = authState;


    const getClassName = (activeMenu) => {
        let activeLink = location.pathname;
        if (activeLink === activeMenu) {
            return "nav-link"
        } else {
            return "nav-link collapsed"
        }
    }

    const handleLogout = () => {
        logout();
        authDispatch({ type: "LOGOUT" });
        navigate('/login');
    }

    const toggleSidebar = () => {
        if (!document.body.classList.contains('toggle-sidebar') && window.innerWidth <= 1199) {
            document.body.classList.add("toggle-sidebar");
        } else {
            document.body.classList.remove("toggle-sidebar");
        }
    }

    const setModuleInfo = (module_id) => {
        localStorage.setItem('current_module_id', module_id)
    }

    // Shared active style — soft blue fill, dark text (no high-contrast gradient)
    const activeItemStyle = {
        background: "#e8edf8",
        color: "#1e3a6e",
    };

    const defaultItemStyle = {
        background: "transparent",
        color: "#4b5563",
    };

    const hoverBg = "#f0f3fa";

    return (
        <>
            <aside id="sidebar" className="sidebar"
                style={{
                    background: "#fafbfd",
                    borderRight: "1px solid #e8ecf4",
                    boxShadow: "2px 0 16px rgba(15,37,87,0.04)"
                }}>

                <ul className="sidebar-nav" id="sidebar-nav" style={{ padding: "8px 12px" }}>

                    {/* Dashboard */}
                    <li className="nav-item">
                        <Link
                            to="/"
                            onClick={toggleSidebar}
                            className={getClassName("/")}
                            style={{
                                display: "flex", alignItems: "center", gap: "10px",
                                padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                                fontSize: "13px", fontWeight: "600", textDecoration: "none",
                                transition: "all 0.15s",
                                ...(location.pathname === "/" ? activeItemStyle : defaultItemStyle)
                            }}
                            onMouseEnter={e => { if (location.pathname !== "/") e.currentTarget.style.background = hoverBg }}
                            onMouseLeave={e => { if (location.pathname !== "/") e.currentTarget.style.background = "transparent" }}
                        >
                            <span style={{
                                width: "28px", height: "28px", borderRadius: "8px", flexShrink: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: location.pathname === "/" ? "#c9d6ee" : "#eef0ff"
                            }}>
                                <i className="bi bi-grid-fill" style={{ fontSize: "13px", color: "#1e3a6e" }}></i>
                            </span>
                            <span className="flex-grow-1 fw-bold">Dashboard</span>
                        </Link>
                    </li>

                    {/* Dynamic Menu */}
                    {menu_access?.map((user_menu, idx) => {
                        const isActive = user_menu?.subMenuAccess?.some(s => location.pathname === s?.route_to);
                        const isTopActive = location.pathname === user_menu?.route_to;

                        if (user_menu?.subMenuAccess?.length > 0) {
                            return (
                                <li className="nav-item" key={idx}>
                                    <Link
                                        className="nav-link collapsed d-flex align-items-center gap-2"
                                        data-bs-target={"#" + user_menu.slug}
                                        data-bs-toggle="collapse"
                                        to="#"
                                        onClick={() => setModuleInfo(user_menu?.module_id)}
                                        style={{
                                            padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                                            fontSize: "13px", fontWeight: "600", textDecoration: "none",
                                            transition: "all 0.15s",
                                            background: isActive ? "#e8edf8" : "transparent",
                                            color: isActive ? "#1e3a6e" : "#4b5563",
                                        }}
                                        onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = hoverBg }}
                                        onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = "transparent" }}
                                    >
                                        <span style={{
                                            width: "28px", height: "28px", borderRadius: "8px", flexShrink: 0,
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            background: isActive ? "#c9d6ee" : "#eef0ff"
                                        }}>
                                            <i className={user_menu?.m_icon} style={{ fontSize: "13px", color: "#1e3a6e" }}></i>
                                        </span>
                                        <span className="flex-grow-1 fw-bold">{user_menu?.name}</span>
                                        <i className="bi bi-chevron-down ms-auto" style={{ fontSize: "10px", color: "#a0aec0", transition: "transform 0.2s" }}></i>
                                    </Link>

                                    <ul
                                        id={user_menu.slug}
                                        className="nav-content collapse"
                                        data-bs-parent="#sidebar-nav"
                                        style={{ paddingLeft: "0", listStyle: "none" }}
                                    >
                                        {user_menu?.subMenuAccess?.map((sub_menu, sidx) => {
                                            const subActive = location.pathname === sub_menu?.route_to;
                                            return (
                                                <li key={sidx} style={{ paddingLeft: "8px" }}>
                                                    <Link
                                                        to={sub_menu?.route_to}
                                                        onClick={toggleSidebar}
                                                        style={{
                                                            display: "flex", alignItems: "center", gap: "10px",
                                                            padding: "8px 12px", borderRadius: "8px", marginBottom: "2px",
                                                            fontSize: "12px", fontWeight: subActive ? "700" : "500",
                                                            textDecoration: "none", transition: "all 0.15s",
                                                            background: subActive ? "#dde5f5" : "transparent",
                                                            color: subActive ? "#1e3a6e" : "#6b7280"
                                                        }}
                                                        onMouseEnter={e => { if (!subActive) e.currentTarget.style.background = hoverBg }}
                                                        onMouseLeave={e => { if (!subActive) e.currentTarget.style.background = "transparent" }}
                                                    >
                                                        <span style={{
                                                            width: "5px", height: "5px", borderRadius: "50%", flexShrink: 0,
                                                            background: subActive ? "#1e3a6e" : "#b0bac9"
                                                        }}></span>
                                                        <i className={sub_menu?.m_icon} style={{ fontSize: "12px" }}></i>
                                                        <span>{sub_menu?.name}</span>
                                                    </Link>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </li>
                            );
                        } else {
                            return (
                                <li className="nav-item" key={idx}>
                                    <Link
                                        to={user_menu?.route_to}
                                        onClick={() => setModuleInfo(user_menu?.module_id)}
                                        style={{
                                            display: "flex", alignItems: "center", gap: "10px",
                                            padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                                            fontSize: "13px", fontWeight: "600", textDecoration: "none",
                                            transition: "all 0.15s",
                                            ...(isTopActive ? activeItemStyle : defaultItemStyle)
                                        }}
                                        onMouseEnter={e => { if (!isTopActive) e.currentTarget.style.background = hoverBg }}
                                        onMouseLeave={e => { if (!isTopActive) e.currentTarget.style.background = "transparent" }}
                                    >
                                        <span style={{
                                            width: "28px", height: "28px", borderRadius: "8px", flexShrink: 0,
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            background: isTopActive ? "#c9d6ee" : "#eef0ff"
                                        }}>
                                            <i className={user_menu?.m_icon} style={{ fontSize: "13px", color: "#1e3a6e" }}></i>
                                        </span>
                                        <span className="flex-grow-1 fw-bold">{user_menu?.name}</span>
                                    </Link>
                                </li>
                            );
                        }
                    })}

                    {/* Section Divider */}
                    {/* <li style={{
                        fontSize: "10px", fontWeight: "700", color: "#a0aec0",
                        textTransform: "uppercase", letterSpacing: "1px",
                        padding: "16px 12px 6px"
                    }}>Pages</li> */}

                    {/* Profile */}
                    {/* <li className="nav-item">
                        <Link
                            to="/profile"
                            onClick={toggleSidebar}
                            style={{
                                display: "flex", alignItems: "center", gap: "10px",
                                padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                                fontSize: "13px", fontWeight: "600", textDecoration: "none",
                                transition: "all 0.15s",
                                ...(location.pathname === "/profile" ? activeItemStyle : defaultItemStyle)
                            }}
                            onMouseEnter={e => { if (location.pathname !== "/profile") e.currentTarget.style.background = hoverBg }}
                            onMouseLeave={e => { if (location.pathname !== "/profile") e.currentTarget.style.background = "transparent" }}
                        >
                            <span style={{
                                width: "28px", height: "28px", borderRadius: "8px", flexShrink: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: location.pathname === "/profile" ? "#c9d6ee" : "#eef0ff"
                            }}>
                                <i className="bi bi-person-circle" style={{ fontSize: "13px", color: "#1e3a6e" }}></i>
                            </span>
                            <span>Profile</span>
                        </Link>
                    </li> */}

                    {/* Logout */}
                    {/* <li className="nav-item">
                        <Link
                            to="#"
                            onClick={handleLogout}
                            style={{
                                display: "flex", alignItems: "center", gap: "10px",
                                padding: "10px 12px", borderRadius: "10px", marginBottom: "2px",
                                fontSize: "13px", fontWeight: "600", textDecoration: "none",
                                transition: "all 0.15s",
                                background: "transparent", color: "#e05252"
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = "#fdf0f0"}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                        >
                            <span style={{
                                width: "28px", height: "28px", borderRadius: "8px", flexShrink: 0,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: "#fde8e8"
                            }}>
                                <i className="bi bi-box-arrow-right" style={{ fontSize: "13px", color: "#e05252" }}></i>
                            </span>
                            <span>Logout</span>
                        </Link>
                    </li> */}

                </ul>
            </aside>
        </>
    )
}

export default SideBar